import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../context/LangContext';
import CartContent from '../components/CartContent';
import Sheet, { SheetHeader, SheetBody } from '../lib/ui/Sheet';

export default function CartOverlay() {
  const { lang, t } = useLang();
  const te = lang === 'te';
  const navigate = useNavigate();
  const close = () => navigate(-1);

  return (
    <Sheet open onClose={close} labelledBy="cart-title">
      <SheetHeader title={`${t.cartTitle} 🛒`} onClose={close} />
      <SheetBody>
        <CartContent onCheckout={() => navigate('/checkout')} />
      </SheetBody>
    </Sheet>
  );
}
